import axios from 'axios'
export default {
	_get (url) {
		return axios.get('gestion-horaria/php/api/' + url)
	},
	_post (uri, data) {
		return axios.post('gestion-horaria/php/api/' + uri, data)
	},
	getResumen (mio) {
		if (mio) {
			return this._get('getResumenEmpleados.php?yo=1')
		} else {
			return this._get('getResumenEmpleados.php')
		}
	},
	getRegistro (idRegistro) {
		return this._get('get-registro.php?ID_registro=' + idRegistro)
	},
	setRegistro (data) {
		return this._post('set-registro.php', data)
	},
	misHoras (filtro) {
		return this._post('get-mis-horas.php', filtro)
	},
	getListado (filtro) {
		return this._post('get-listado.php', filtro)
	},
	infoUsuario (idUsuario) {
		const data = {
			ID_usuario: idUsuario
		}

		return this._post('get-usuario.php', data)
	},
	soyLider () {
		return this._get('soy-lider.php')
	},
	validar (idRegistro) {
		const data = {
			ID_registro: idRegistro
		}
		return this._post('validar.php', data)
	},
	validarTodo (filtro) {
		return this._post('validar-todo.php', filtro)
	},
	eliminar (idRegistro) {
		const data = {
			ID_registro: idRegistro
		}
		return this._post('eliminar.php', data)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-horaria/vue/api.js